/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CompletionStatusDTO = {
    todo: 'todo',
    done: 'done'
} as const;
export type CompletionStatusDTO = typeof CompletionStatusDTO[keyof typeof CompletionStatusDTO];

